export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7312.a1e17007.jpg";